import React from 'react';
import YoutTubeComp from './YouTubeComp';
import MenuComp from './MenuComp';

function MontaComponente(props) {
    const { cmp, edit } = props

    const doc = new DOMParser().parseFromString(cmp, "text/xml");
    const el = doc.firstChild;

    if (el.getAttribute("nome") === "YouTubeComp") {
        return (
            <YoutTubeComp tipo={el.getAttribute("tipo")} edit={edit} />
        )
    }
    if (el.getAttribute("nome") === "Menu") {
        return (
            <MenuComp tipo={el.getAttribute("tipo")} nomePagina={el.getAttribute("pagina")} edit={edit} />
        );
    }

    return (
        <div>{cmp}</div>
    )
}
const HtmlContent = (props) => {
    const { htmlString, edit } = props;
    const containerRef = React.useRef(null);
    const [hasSpecialScript, setHasSpecialScript] = React.useState(false);
    
    React.useMemo(() => {
        setHasSpecialScript(htmlString.includes('execute-react="true"'));
    }, [htmlString]);

    React.useEffect(() => {
        if (!containerRef.current) return;

        // Parse do HTML para extrair scripts
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const scripts = doc.querySelectorAll('script[execute-react="true"]');

        // Remove os scripts especiais do HTML
        scripts.forEach(script => script.remove());

        containerRef.current.innerHTML = doc.body.innerHTML;

        // Executa os scripts especiais
        scripts.forEach(script => {
            const newScript = document.createElement('script');
            newScript.text = script.textContent;
            
            document.body.appendChild(newScript);
            document.body.removeChild(newScript);

        });

        const styles = doc.querySelectorAll('style');
        if (styles && styles.length > 0) {
            const arrEl = [];
            for(let css of styles){
                const styleElement = document.createElement('style');
                styleElement.textContent = css.textContent;
                document.head.appendChild(styleElement);
                arrEl.push(styleElement)
            }

            return () => {
                for( let el of arrEl){
                    document.head.removeChild(el);
                }
            };
        }

    }, [
        htmlString, 
        hasSpecialScript, 
    ]);

    if (hasSpecialScript) {
        return <div ref={containerRef} id='home-page' />;
    }
    let arr = [];
    let index = 0;
    let tmp = String(htmlString);
    while (tmp.indexOf("<componente") > 0) {
        let pos = tmp.indexOf("<componente");
        let pos2 = tmp.indexOf("</componente>");
        let comp = tmp.substring(pos, pos2 + "</componente>".length)

        arr.push(htmlString.substring(0, pos));
        arr.push(comp);

        tmp = tmp.substring(pos2 + "</componente>".length, htmlString.length);
        if (index++ > 10) break;
    }
    arr.push(tmp);
    if (arr.length > 0) {
        return (
            <React.Fragment>
                {arr.map((c, index) => {
                    if (c.includes("<componente")) {
                        return (
                            <MontaComponente cmp={c} edit={edit} key={index} />
                        )
                    }
                    return (
                        <div key={index}
                            dangerouslySetInnerHTML={{ __html: c }}
                        />
                    )
                })}
            </React.Fragment>
        )
    } else {
        return (
            <div style={{ minWidth: 500 }} id='home-page'
                dangerouslySetInnerHTML={{ __html: htmlString }}
            />
        );
    }
};


export default HtmlContent;